import { inject, InjectionToken } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { authGuard } from '../../auth/auth-guard.service';

/** Token for the incidents feature auth guard. Host app provides the actual guard. */
export const INCIDENTS_AUTH_GUARD = new InjectionToken<CanActivateFn>('INCIDENTS_AUTH_GUARD', {
  providedIn: null,
  factory: () => authGuard(),
});

/** Delegates to the guard provided via INCIDENTS_AUTH_GUARD. Use in incidents routes. */
export const incidentsGuard: CanActivateFn = (route, state) => {
  return inject(INCIDENTS_AUTH_GUARD)(route, state);
};
